import React, {useEffect} from 'react'
import WbModal from '../../../components/common/WbModal'
import tagsApi from '../../../services/api/questionLibrary/tagsApi'
import {
  AccordionDetails,
  Alert,
  Button,
  Icon,
  IconButton,
  InputAdornment,
  Paper,
  Stack,
  TextField,
} from '@mui/material'
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import CategoryQuestions from '../../../components/screens/surveyForms/questions/QuestionLibrary/CategoryQuestions'
import WbLoader from '../../../components/common/WbLoader'
import WbTextField from '../../../components/common/WbTextField'
import {Search} from '@mui/icons-material'

export default function QuestionLibrary({
  survey,
  questions,
  setQuestions,
  view,
}) {
  const [selectedTag, setSelectedTag] = React.useState(null)

  const [tags, setTags] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  const [search, setSearch] = React.useState('')
  const [showSearch, setShowSearch] = React.useState(false)
  const isQuestionBank = view === 'library'

  useEffect(() => {
    setLoading(true)
    tagsApi
      .getTagsByAudience(
        survey.audience,
        view === 'library' ? 0 : survey.schoolId,
        view === 'library' ? 0 : survey.matId
      )
      .then(res => {
        setTags([...res.sort((a, b) => a.name.localeCompare(b.name))])
      })
      .finally(() => setLoading(false))
  }, [view])

  return loading ? (
    <WbLoader />
  ) : (
    <>
      <WbTextField
        label="Search"
        fullWidth
        value={search}
        endAdornment={
          <InputAdornment position="end">
            <Search />
          </InputAdornment>
        }
        onChange={e => setSearch(e.target.value)}
        onKeyPress={e => e.key === 'Enter' && setShowSearch(true)}
      />
      {tags.map(tag => (
        <div
          className="questions-library"
          style={{cursor: 'pointer'}}
          onClick={e => setSelectedTag(tag)}
        >
          <AccordionDetails>
            <Stack
              direction={'row'}
              justifyContent="space-between"
              alignItems="center"
              className="question-bank-list"
            >
              <div className="question-txt">{tag.name}</div>
              <div>
                <ArrowForwardIosSharpIcon sx={{fontSize: '12px'}} />
              </div>
            </Stack>
          </AccordionDetails>
        </div>
      ))}

      {tags.length === 0 && (
        <Alert security="info" variant="outlined" severity="info">
          No data available
        </Alert>
      )}

      {(selectedTag || showSearch) && (
        <WbModal
          width={'80%'}
          onClose={() => {
            setSelectedTag(null)
            setShowSearch(false)
            setSearch('')
          }}
          title={selectedTag ? selectedTag.name : search}
          content={
            <CategoryQuestions
              isAdmin={isQuestionBank}
              survey={survey}
              surveyQuestions={questions}
              tag={selectedTag}
              text={search}
              tagsList={tags.map(t => t.id)}
              setSurveyQuestions={setQuestions}
              onClose={() => setSelectedTag(null)}
              view={view}
            />
          }
        ></WbModal>
      )}
    </>
  )
}
